import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { LayoutService } from '@core/data/layout.service';
import { AuthenticationService } from '@pages/auth/_services';
import { User } from '@pages/auth/_models/user';
import { UtilityService } from '@core/data/utility.service';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

    @Input() position = 'normal';
    userMenu = [{ title: 'صفحه شخصی' }, { title: 'خروج', link: 'auth/logout' }];
    isGrid: boolean = false;
    isAccounting;

    currentUser: User;

    constructor(
        private auth: AuthenticationService,
        private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private layoutService: LayoutService,
        private utils: UtilityService
    ) {
        this.auth.currentUser.subscribe(x => this.currentUser = x);
    }

    ngOnInit() {
        this.layoutService.headerBtn$.subscribe(btnState => {
            this.isGrid = btnState;
        });
        this.layoutService.accountingTotal$.subscribe(total => {
            this.isAccounting = this.utils.formatNumber(total);
        });
    }

    toggleSidebar(name, toggle: boolean = true): boolean {
        this.sidebarService.toggle(toggle, name);
        this.layoutService.changeLayoutSize();
        return false;
    }

    goToHome() {
        this.menuService.navigateHome();
    }

    startSearch() { }
}
